import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { sessionDetailState } from '../../../recoil/atom/sessionDetailState';

function EditSession({ setScreen }) {
    const [selectedSession, setSelectedSession] = useState("");
    const [sessionDetails, setSessionDetails] = useRecoilState(sessionDetailState);
    
    console.log(sessionDetails);

    const updateSelectedSession = (e) => {
        const index = e.target.value;
        setSelectedSession(index);
        setSessionDetails( prevDetails => ({
            ...prevDetails,
            selectedSession: index
        }))
    }

    const handleInputChange = (index, key, value) => {
        setSessionDetails(prevDetails => {
            const updatedSessions = prevDetails.sessions.map((session, i) => 
                i === parseInt(index) ? { ...session, meta: { ...session.meta, [key]: value } } : session
            );
            return {
                ...prevDetails,
                sessions: updatedSessions
            };
        });
    };
    

    return (
        <>
            <h4
                style={{
                    margin: "auto",
                    textAlign: "center",
                    backgroundColor: "#02111B",
                    color: "#6BF178",
                    marginBottom: ".5em",
                    width: "75%",
                    padding: ".5em",
                    marginTop: "-2.25em",
                    border: "double .25em",
                    lineHeight: "1.2"
                }}
            >
                Edit Sessions
            </h4>
            <p>
                View and edit existing sessions below.
            </p>
            <div style={{margin: ".5em"}}>
                <select
                    onChange={updateSelectedSession}
                    value={selectedSession}
                    style={{
                        display: "block",
                        margin: "auto",
                        backgroundColor: "#02111B",
                        color: "#6bf178",
                        border: "medium outset #6bf178",
                        padding: ".5em",
                        fontSize: "1em",
                        outline: "#02111b solid .1em"
                    }}
                >
                    <option value={""} onChange={updateSelectedSession} >Select A Session</option>
                    {
                        sessionDetails.sessions.map((session, index)=> (
                            <option key={index} value={index} onChange={updateSelectedSession}>{session.meta.name}</option>
                        ))
                    }
                </select>
            </div>
            {
                selectedSession !== null && selectedSession !== "" && (
                 <>
                    <div style={{margin: ".5em"}}>
                        <input placeholder="Enter a name"
                            onChange={e => handleInputChange(selectedSession, 'name', e.target.value)} 
                            value={sessionDetails.sessions[selectedSession].meta.name}
                            style={{
                            backgroundColor: "#02111b",
                            color: "#6bf178",
                            border: "#6bf178 .25em ridge",
                            fontFamily: "Print Char",
                            padding: ".5em",
                            width: "90%",
                            margin: "auto"
                        }} />
                    </div>
                    <div style={{margin: ".5em"}}>
                        <textarea 
                            placeholder="Enter a description" 
                            onChange={e => handleInputChange(selectedSession, 'description', e.target.value)}
                            value={sessionDetails.sessions[selectedSession].meta.description}
                            style={{
                                backgroundColor: "#02111b",
                                color: "#6bf178",
                                border: "#6bf178 .25em ridge",
                                fontFamily: "Print Char",
                                padding: ".5em",
                                width: "90%",
                                margin: "auto",
                                minHeight: "5em"
                                
                            }} />
                    </div>
                 </>   
                )
            }
        </>
    )
}
export default EditSession
